import { styled } from "twin.macro";
import React from "react";

type Props = {
  type?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  text: string;
};

const StyledHeadline = styled.div`
  @media (max-width: 1024px) {
    br {
      display: none;
    }
  }
`;

export function parseTextWithHighlights(text: string) {
  const parts = text.split(/\[|\]/);

  return parts.map((part, idx) => {
    if (idx % 2 === 1) {
      return (
        <span tw="text-green-80" key={idx}>
          {part}
        </span>
      );
    } else {
      return <React.Fragment key={idx}>{part}</React.Fragment>;
    }
  });
}

export function Headline(props: Props & React.ComponentPropsWithRef<"div">) {
  const { type = "h1", text, ...rest } = props;

  const chunks = text.split("\n");

  return (
    <StyledHeadline as={type} {...rest}>
      {chunks.map((item, idx) => (
        <React.Fragment key={idx}>
          {parseTextWithHighlights(item)}
          {chunks.length - 1 !== idx && <br />}
        </React.Fragment>
      ))}
    </StyledHeadline>
  );
}
